import { Injectable } from '@angular/core';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { Lot } from '../../models/Lot';
import { TypeLotsDivers } from '../../models/TypeLotsDivers';

@Injectable({
  providedIn: 'root'
})
export class LotsService {

  constructor() {
  }

  public getLots(controls: any, formExtractorService: FormExtractorService) {

    let lot_iter = 0;

    const lot_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_TypeAnn_DIVER_G1'], 'SepSep_TypeLotsDivers_index_');

    const lots = new TypeLotsDivers();
    for (const lot of Array.from(lot_iters)) {
      lots.lot[lot_iter] = new Lot();
      lots.lot[lot_iter].description = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_TypeLotsDivers_index_' + (lot_iter + 1) + '_SepSep_Lot_SepAtt_description'));
      lots.lot[lot_iter].infosComplementaires = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_TypeLotsDivers_index_' + (lot_iter + 1) + '_SepSep_Lot_SepAtt_infoComplementaires'));
      lots.lot[lot_iter].numLot = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_TypeLotsDivers_index_' + (lot_iter + 1) + '_SepSep_Lot_SepAtt_numLot'));
      lot_iter++;
    }

    if (controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_TypeLotsDivers_SepAtt_plusieursLot') === true) {
      lots.plusieursLot = '';
    } else {
      lots.plusieursLot = null;
    }
    if (controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_TypeLotsDivers_SepAtt_tousLots') === true) {
      lots.tousLots = '';
    } else {
      lots.tousLots = null;
    }
    if (controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_TypeLotsDivers_SepAtt_unLot') === true) {
      lots.unLot = '';
    } else {
      lots.unLot = null;
    }

    return lots;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
